import React, { useState, useEffect, useRef, useContext, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getDocumentFilterTabs, isPeriodClosedError } from "src/utils/documentsI18n";
import TablaFila from "./TablaFila";
import TablaFilaSidebar from "./TablaFilaSidebar";
import LoadingCard from "../general/js/loadingCard";
import LoadingSpinner from "../general/js/spinnerLoading";
import { Button, Form, Header, Input, Pagination, Dropdown, Menu, Icon, Popup } from "semantic-ui-react";
import { formatMoneyWithCurrency } from "../../utils/formatter";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedDocuments,
  importDocumentsTypes,
  importSelectedType,
  importExcludedDocumentCodes,
  setUpdateDocuments,
  importDocumentsFilter,
  setUpdateDocumentsTypes,
} from "../../redux/actions/documentostributarios";
import { importLastUpdateDateSiiBot } from 'src/redux/actions/botLastUpdateDate'
import useMediaQuery from "@material-ui/core/useMediaQuery";
import "./nuevaTablaDocumentos.scss";
import { importNewModal } from "../../redux/actions/newModal";
import { importAlertState } from "../../redux/actions/alert";
import { parseObligation } from "../general/js/forms/crearObligacion/functions";
import { CreateObligation } from "../../graphql/obligations";
import { GenerateMultipleMatch } from "../../graphql/conciliacion";
import { BotUpdateDate } from "../../graphql/botsWs";
import moment from "moment";
import {
  FindAndSettleDocuments,
  FindAndSettleDocumentsById,
  FindDocumentById,
  SettleDocument,
} from "src/graphql/documents";
import Reconcile from "../general/js/forms/reconcile";
import iconEquis from 'src/assets/pepper-icons/rightbar/icon_equis.svg';
import { formatMoney, moneyToNumber } from "../../utils/formatter";
import { Counter } from "../general/js/counter";
import { importUpdateNominaInProcessNeeded } from "src/redux/actions/proveedores";
import { useHistory, useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { importOpenSidebar } from "src/redux/actions/openSidebar";
import { parseFilterInput } from "../general/js/forms/filtroDocumentos/functions";
import { debounce } from "src/utils/debounce";
import CostCenterModal from "./CostCenterModal";
import CustomModal from "../configuracion/components/customModal";

import { Plans } from "src/utils/plans";
import { CompanyContext } from "src/context";
import { showAccounting } from "src/utils/accounting";
import { BulkActionsBar } from "../widgets/bulkActionsBar/bulkActionsBar";
import FilterTabs from "../FilterTabs";
import { getCssColors } from "src/scss/theme";
import { DocumentFilters } from "../general/js/forms/filtroDocumentos";
import ModuleSearchBar from "../shared/ModuleSearchBar";
import { DeleteDocuments } from "../../graphql/taxDocument";
import ModalDeleteObligations from "./ModalDeleteObligations";
import CreateJournalEntryModal from "../general/js/forms/reconcile/contabilidad/CreateJournalEntryModal";
import CreateObligationModal from "../configuracion/createObligationModal/createObligationModal";
import PaymentMethodDropdown from "../general/js/forms/reconcile/components/PaymentMethodDropdown";
import { getObligationTypeForPaymentMethod } from "src/utils/paymentMethodObligationType";
import { useBlockedFeatures } from "src/hooks/useBlockedFeatures";
import { DIN_EXCLUDED_DOCUMENT_CODES, isDinPath } from "./dinRowHelpers";
import BulkUnmatchModal from "../general/js/forms/reconcile/BulkUnmatchModal";
import BulkUnmatchProgress from "../general/js/forms/reconcile/BulkUnmatchProgress";
import { useBulkUnmatch } from "../general/js/forms/reconcile/hooks/useBulkUnmatch";

/** Obligación de retención como documento propio, junto a su boleta. */
const toBoletaRetentionDocument = (boleta, typeLabel) => {
  const retention = boleta?.bhRetention;
  if (!retention?.id) return null;
  const meta = boleta.meta || {};
  const amount = Number(retention.amount) || 0;
  const remaining = retention.remaining == null ? amount : Number(retention.remaining) || 0;
  const inMatch = Number(retention.inMatch) || 0;
  const outMatch = Number(retention.outMatch) || 0;
  return {
    _id: String(retention.id),
    id: String(retention.id),
    companyId: boleta.companyId,
    documentType: "OBLIGATION",
    documentDate: boleta.documentDate,
    paymentDate: retention.paymentDate || null,
    currencyType: boleta.currencyType || "CLP",
    amount,
    meta: {
      type: "retencionboletashonorarios",
      typeLabel,
      documentId: meta.documentId,
      number: meta.documentId,
      documentCode: meta.documentCode,
      issuerId: meta.issuerId,
      issuerName: meta.issuerName,
      receiverId: meta.receiverId,
      receiverName: meta.receiverName,
      isReceived: meta.isReceived,
      isPaid: retention.isPaid === true,
      isValid: retention.isValid !== false,
      remaining,
      amount,
      originalAmount: amount,
      matchs: {
        inMatch: Array.from({ length: inMatch }, () => ({})),
        outMatch: Array.from({ length: outMatch }, () => ({})),
      },
    },
  };
};

/**
 * Filas por documento según el filtro `bhView`:
 * sin filtro, boleta + retención armada desde `bhRetention`; "BOLETAS", solo la
 * boleta (el backend no adjunta la retención); "RETENCIONES", el backend ya
 * devuelve las obligaciones de retención, que se muestran tal cual.
 */
const getBoletaRows = (doc, retentionLabel, view) => {
  if (view === "RETENCIONES") return [{ data: doc, isRetention: true }];
  if (view === "BOLETAS") return [{ data: doc, isRetention: false }];
  const retention = toBoletaRetentionDocument(doc, retentionLabel);
  return retention
    ? [{ data: doc, isRetention: false }, { data: retention, isRetention: true }]
    : [{ data: doc, isRetention: false }];
};

const TablaDocumentos = ({
  data = {},
  index,
  fetching,
  limit = 50,
  setLimit,
  selectedDocs,
  setSelectedDocs,
  OFFSET = 50,
  small = false,
  setEditTitle,
  deleteMultipleDocuments,
  eerrAreas,
  selected,
  selectedAmountDocs,
  setSelectedAmountDocs,
  currentPage,
  setCurrentPage,
  onOpenReconcile,
  renderFilters, // Callback to render filters in parent
}) => {
  const { t, i18n } = useTranslation("documents");
  const { t: tAccounting } = useTranslation("accounting");
  const dispatch = useDispatch();
  const { isAbonarBlocked, isCrearObligacionBlocked, isConciliacionBlocked } = useBlockedFeatures();
  const history = useHistory();
  const location = useLocation();
  // Keep header + rows aligned by sharing the exact same actions/progress column width.
  // (If this differs between header and rows, the left grid’s available width changes and columns drift.)
  const PROGRESS_COL_WIDTH_PX = 176;
  const { roles } = useSelector((state) => state.auth);
  const { openSidebar: show } = useSelector((state) => state.openSidebar);
  const showDiv = show.show;
  
  // Detect documentId from URL
  const searchParams = new URLSearchParams(location.search);
  const documentIdFromUrl = searchParams.get('documentId');
  const isDetailView = searchParams.get('isDocumentDetail') === 'true';
  
  // Fetch document from URL if present - use FindDocumentById instead of GetDocumentById
  const {
    data: urlDocumentData,
    fetching: urlDocumentFetching,
    reexecuteQuery: refetchDocument,
  } = FindDocumentById({
    ids: documentIdFromUrl ? [documentIdFromUrl] : [],
  });
  
  const [showBulkUnmatchModal, setShowBulkUnmatchModal] = useState(false);

  // State for inner sidebar
  const [showReconcilePanel, setShowReconcilePanel] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  
  // Get updateDocuments from Redux early so it can be used in useEffect
  const { updateDocuments } = useSelector((state) => state.documentostributarios);
  
  // Handle URL-based opening/closing - panel opens/closes based on documentId in URL
  useEffect(() => {
    const currentSearchParams = new URLSearchParams(location.search);
    
    // FindDocumentById returns an array, get first document
    const fetchedDocuments = urlDocumentData?.findDocumentsById || [];
    const fetchedDocument = fetchedDocuments[0];
    
    if (documentIdFromUrl && fetchedDocument) {
      const document = fetchedDocument;
      
      // Set selectedDocumentId to highlight the row in the list (only if ID changed)
      if (selectedDocument?.id !== document.id && selectedDocument?._id !== document._id) {
        setSelectedDocumentId(document._id || document.id);
      }
      
      // Always update state and Redux when document data changes
      setSelectedDocument(document);
      setShowReconcilePanel(true);
      
      // Check if isComment parameter is in URL to determine activeIndex
      const isComment = currentSearchParams.get('isComment') === 'true';
      const isAccounting = currentSearchParams.get('isAccounting') === 'true';
      const isFiles = currentSearchParams.get('isFiles') === 'true';
      const activeIndex = isComment ? 2 : (isAccounting ? 1 : (isFiles ? 3 : 0));
      
      // Always update Redux with latest document data
      dispatch(
        importOpenSidebar({
          show: false,
          reconcile: true,
          editData: document,
          options: { type: "documents", activeIndex },
        })
      );
    } else if (documentIdFromUrl) {
      setShowReconcilePanel(true);

      const isComment = currentSearchParams.get('isComment') === 'true';
      const isAccounting = currentSearchParams.get('isAccounting') === 'true';
      const isFiles = currentSearchParams.get('isFiles') === 'true';
      const activeIndex = isComment ? 2 : (isAccounting ? 1 : (isFiles ? 3 : 0));

      // Mientras carga (o aún no hay respuesta), mantener panel abierto sin borrar documentId de la URL
      if (urlDocumentFetching || urlDocumentData == null) {
        dispatch(
          importOpenSidebar({
            show: false,
            reconcile: true,
            editData: null,
            options: { type: 'documents', activeIndex },
          })
        );
        return;
      }

      const loadedId = fetchedDocument?._id || fetchedDocument?.id;
      if (!loadedId || String(loadedId) !== String(documentIdFromUrl)) {
        setSelectedDocument(null);
        dispatch(
          importOpenSidebar({
            show: false,
            reconcile: true,
            editData: null,
            options: { type: 'documents', activeIndex },
          })
        );
      }
    } else if (!documentIdFromUrl && showReconcilePanel) {
      // Close panel when documentId is removed from URL
      setShowReconcilePanel(false);
      setSelectedDocument(null);
      setSelectedDocumentId(null);
      
      // Clear Redux state
      dispatch(
        importOpenSidebar({
          show: false,
          reconcile: false,
          editData: null,
        })
      );
    }
  }, [
    documentIdFromUrl,
    urlDocumentData?.findDocumentsById,
    urlDocumentFetching,
    urlDocumentData,
    location.search,
    dispatch,
    selectedDocument,
    showReconcilePanel,
  ]);
  
  // Sync selectedDocumentId with URL even if document data hasn't loaded yet
  useEffect(() => {
    if (documentIdFromUrl && documentIdFromUrl !== selectedDocumentId) {
      setSelectedDocumentId(documentIdFromUrl);
    } else if (!documentIdFromUrl && selectedDocumentId) {
      setSelectedDocumentId(null);
    }
  }, [documentIdFromUrl, selectedDocumentId]);
  
  // Refetch selected document when updateDocuments is true
  // Skip refetch if we're in comments tab (comments handle their own refetch)
  useEffect(() => {
    const isComment = searchParams.get('isComment') === 'true';
    if (updateDocuments?.value && documentIdFromUrl && refetchDocument && !isComment) {
      refetchDocument();
    }
  }, [updateDocuments?.value, documentIdFromUrl, refetchDocument, searchParams]);
  
  const handleOpenReconcile = (document) => {
    // NOTE: We don't set state or dispatch Redux here because the URL change
    // (which happens in TablaFila before this is called) will trigger
    // the useEffect above which handles fetching and Redux dispatch.
    // This prevents duplicate API calls.
  };
  
  const handleCloseReconcile = () => {
    setShowReconcilePanel(false);
    setSelectedDocument(null);
    setSelectedDocumentId(null);
    
    // Clear documentId from URL; drop list filter `id` only when it was paired with this panel (avoid breaking isGlobalSearch-only `id` flows)
    const currentParams = new URLSearchParams(location.search);
    const removedDocumentId = currentParams.get('documentId');
    currentParams.delete('documentId');
    const listId = currentParams.get('id');
    if (removedDocumentId && listId === removedDocumentId) {
      currentParams.delete('id');
    }
    history.replace({ search: currentParams.toString() });
    
    // Also close Redux sidebar state to prevent external sidebar from opening
    dispatch(
      importOpenSidebar({
        show: false,
        reconcile: false,
        editData: null,
      })
    );
  };
  
  const { executeMutation: createObligation } = CreateObligation();
  const { executeMutation: generateMultipleMatch } = GenerateMultipleMatch();
  const { executeMutation: findAndSettleDocuments } = FindAndSettleDocuments();
  const { executeMutation: findAndSettleDocumentsById } = FindAndSettleDocumentsById();
  const { executeMutation: settleDocument } = SettleDocument()
  const {
    selectedType,
    selectedDocuments: selectedClient,
    doctrib,
    documentsFilter,
    totalDocs
  } = useSelector((state) => state.documentostributarios);
  const boletaView = documentsFilter?.bhView;
  
  // Panel visibility is controlled by URL - layout opens as soon as documentId is present
  const isDetailLayout = !!documentIdFromUrl;
  const { lastUpdateDateSiiBot } = useSelector((state) => state.botLastUpdateDate)
  const [selectedAmount, setSelectedAmount] = useState(0);
  const today = new Date().toISOString().split("T")[0]
  const [dateToSettle, setDateToSettle] = useState(today);
  const [nameFilter, setNameFilter] = useState();
  const [amountToShow, setAmountToShow] = useState(0)
  const [open, setOpen] = useState(false)
  const [openCostCenterModal, setOpenCostCenterModal] = useState(false)
  const [showDeleteObligationsModal, setShowDeleteObligationsModal] = useState(false)
  const [showBulkJournalEntryModal, setShowBulkJournalEntryModal] = useState(false)
  const [showAbonoModal, setShowAbonoModal] = useState(false)
  const [preSelectedObligationType, setPreSelectedObligationType] = useState(null);
  const [isPaymentMethod, setIsPaymentMethod] = useState(false);
  const [settleDropdownIsOpen, setSettleDropdownIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(50);
  const [totalPages, setTotalPages] = useState();
  const tableRef = useRef(null);
  const prevReconcileOpenRef = useRef(false); // Track open transition to center selected row once
  const [excludedDocuments, setExludedDocuments] = useState([]);
  const [parametersFetched, setParametersFetched] = useState(false);
  const { openSidebar } = useSelector((state) => state.openSidebar);
  const { selectedCompany } = useContext(CompanyContext)

  const showEerr = (selectedCompany && selectedCompany?.plan
    && (selectedCompany?.plan.includes(Plans.smartcfo))
    && selectedCompany?.plan.length == 1);

  const filterTabs = useMemo(
    () => getDocumentFilterTabs(location.pathname),
    [location.pathname]
  );

  const options = [
    { key: 1, text: '20', value: 20 },
    { key: 2, text: '50', value: 50 },
    { key: 3, text: '100', value: 100 },
    { key: 4, text: '200', value: 200 },
  ];

  const [filterDocumentTypesSelected, setFilterDocumentTypesSelected] =
    useState([]);

  const {
    selectedCompany: { id: companyId, plan },
  } = useSelector((state) => state.companyList);
  const { data: UpdateDocsDate, reexecuteQuery } = BotUpdateDate('sii', companyId)

  // Desconciliación masiva: solo los seleccionados que tienen matches.
  const docsWithMatches = (selectedAmountDocs || []).filter((doc) => {
    const matchs = doc?.meta?.matchs || {};
    return (matchs.inMatch?.length || 0) + (matchs.outMatch?.length || 0) > 0;
  });
  // El endpoint exige un único `type` por job (no se mezclan documentos con
  // transacciones). En boletas, boleta y retención son tipos distintos: se
  // manda un job por tipo.
  const bulkUnmatchTypes = [...new Set(docsWithMatches.map((doc) => doc.documentType))];
  const bulkUnmatchType = bulkUnmatchTypes.length === 1 ? bulkUnmatchTypes[0] : null;
  const boletasCanUnmatchByType =
    location.pathname === "/boletas" &&
    bulkUnmatchTypes.length > 1 &&
    bulkUnmatchTypes.every((type) => type && type !== "TRANSACTION");
  const canBulkUnmatch = Boolean(bulkUnmatchType) || boletasCanUnmatchByType;
  const unmatchGroups = bulkUnmatchTypes.map((type) => ({
    type,
    ids: docsWithMatches
      .filter((doc) => doc.documentType === type)
      .map((doc) => doc._id || doc.id),
  }));

  // Al terminar limpia la selección, por el mismo canal que usan las otras
  // acciones masivas de esta tabla.
  const bulkUnmatch = useBulkUnmatch({
    companyId,
    onSettled: () => {
      setSelectedDocs([]);
      if (setSelectedAmountDocs) setSelectedAmountDocs([]);
    },
  })


  const [firstRender, setFirstRender] = useState(true);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const lastStableDocumentsRef = useRef({ docs: [], totalDocs: 0 });
  const { paginatedDocumentsByCompanyAsString } = data || {};
  const Documents = useMemo(() => {
    try {
      if (!paginatedDocumentsByCompanyAsString) {
        return lastStableDocumentsRef.current;
      }
      const parsed = JSON.parse(paginatedDocumentsByCompanyAsString);
      const result = parsed || { docs: [], totalDocs: 0 };
      if ((result.docs?.length ?? 0) > 0 || (result.totalDocs ?? 0) > 0) {
        lastStableDocumentsRef.current = result;
      }
      return result;
    } catch (_) {
      return lastStableDocumentsRef.current;
    }
  }, [paginatedDocumentsByCompanyAsString]);

  const matches = useMediaQuery("(max-width:1360px)");

  const [searchTerm, setSearchTerm] = useState("");

  // Skeleton rows (similar idea to Balance8Columnas)
  const SKELETON_ROWS = 50;

  const getGridTemplateColumnsForPath = useCallback((pathname) => {
    if (pathname === "/cuotas_de_creditos") {
      // Emisión, Nombre, Identificador, Cuota (n°), Capital, Interés, Cuota (monto), Fecha Pago
      return 'minmax(110px, 1.05fr) minmax(140px, 1.4fr) minmax(160px, 1.5fr) minmax(90px, 0.7fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(110px, 0.95fr) minmax(120px, 1.05fr)';
    }
    if (pathname === "/boletas") {
      // Emisión, Razón Social, Rut, Folio, Monto Neto, Retención, Fecha Pago
      // Give extra space to Razón Social
      return 'minmax(110px, 0.9fr) minmax(220px, 2.7fr) minmax(130px, 1fr) minmax(90px, 0.7fr) minmax(130px, 1fr) minmax(130px, 1fr) minmax(120px, 1fr)';
    }
    if (isDinPath(pathname)) {
      return 'minmax(110px, 1fr) minmax(110px, 1fr) minmax(90px, 0.8fr) minmax(90px, 0.8fr) minmax(110px, 1fr) minmax(110px, 1fr) minmax(110px, 1fr)';
    }
    // Default documents (DTEs): Emisión, Razón Social, Rut, Tipo, Folio, Monto, Fecha Pago
    // Give extra space to Razón Social
    return 'minmax(110px, 0.9fr) minmax(240px, 3fr) minmax(130px, 1fr) minmax(200px, 1.6fr) minmax(90px, 0.7fr) minmax(130px, 1fr) minmax(120px, 1fr)';
  }, []);

  const renderSkeletonRow = useCallback((i) => {
    const pathname = location.pathname;
    const gridTemplateColumns = getGridTemplateColumnsForPath(pathname);

    const cell = (w = 'tw-w-3/4') => (
      <div className="tw-px-3 tw-min-w-0">
        <div className={`tw-h-4 tw-bg-gray-200 tw-rounded ${w}`} />
      </div>
    );

    return (
      <div
        key={`doc-skeleton-${i}`}
        className="tw-w-full tw-flex tw-py-2 tw-border-solid tw-border-[1px] tw-border-[#e3eef2] tw-rounded-md tw-shadow-sm tw-mt-2 tw-bg-white tw-animate-pulse"
      >
        <div className="tw-w-full tw-flex tw-py-1 tw-items-center">
          {/* Left Section */}
          <div className="tw-flex tw-items-center tw-px-4 tw-flex-1 tw-min-w-0 tw-gap-8">
            {/* Checkbox */}
            <div className="tw-w-[40px] tw-flex tw-justify-center tw-items-center tw-flex-shrink-0">
              <div className="tw-h-4 tw-w-4 tw-bg-gray-200 tw-rounded" />
            </div>

            <div
              className="tw-grid tw-items-center tw-flex-1 tw-min-w-0 tw-gap-x-2"
              style={{ gridTemplateColumns }}
            >
              {cell('tw-w-20')}
              {cell('tw-w-28')}
              {cell('tw-w-32')}
              {cell('tw-w-16')}
              {cell('tw-w-24')}
              {cell('tw-w-24')}
              {/* Credits have 8 columns; boletas/dtes have 7 */}
              {(pathname === "/cuotas_de_creditos") ? (
                <>
                  {cell('tw-w-24')}
                  {cell('tw-w-20')}
                </>
              ) : (
                cell('tw-w-20')
              )}
            </div>
          </div>

          {/* Right Section (actions placeholder) - keep geometry aligned with TablaFila */}
          <div className="tw-flex tw-flex-nowrap tw-items-center tw-px-3 tw-flex-shrink-0 tw-gap-4 tw-justify-end tw-ml-auto">
            {/* conflict / comments / accounting */}
            <div className="tw-h-5 tw-w-5 tw-bg-gray-200 tw-rounded-full" />
            <div className="tw-h-5 tw-w-5 tw-bg-gray-200 tw-rounded-full" />
            <div className="tw-h-5 tw-w-5 tw-bg-gray-200 tw-rounded-full" />
            {/* progress */}
            <div
              className="tw-h-3 tw-bg-gray-200 tw-rounded"
              style={{
                width: PROGRESS_COL_WIDTH_PX,
                minWidth: PROGRESS_COL_WIDTH_PX,
                maxWidth: PROGRESS_COL_WIDTH_PX,
              }}
            />
          </div>
        </div>
      </div>
    );
  }, [getGridTemplateColumnsForPath, location.pathname, PROGRESS_COL_WIDTH_PX]);

  useEffect(() => {
    if (!fetching && firstRender) {
      setFirstRender(false);
    }
  }, [fetching]);

  useEffect(() => {
    dispatch(setSelectedDocuments(selectedDocs));
  }, [selectedDocs.length]);

  // Scroll to selected document only when reconcile sidebar first opens (not when already open)
  useEffect(() => {
    const wasOpen = prevReconcileOpenRef.current;
    const isOpening = !wasOpen && isDetailLayout; // Only true when transitioning from closed to open

    if (isOpening && selectedDocumentId && tableRef.current) {
      const timeoutId = setTimeout(() => {
        const rowElement = tableRef.current?.querySelector(
          `[data-document-id="${selectedDocumentId}"]`,
        );

        if (rowElement && tableRef.current) {
          const containerRect = tableRef.current.getBoundingClientRect();
          const rowRect = rowElement.getBoundingClientRect();

          const scrollTop = tableRef.current.scrollTop;
          const rowOffsetTop = rowRect.top - containerRect.top + scrollTop;
          const containerHeight = tableRef.current.clientHeight;
          const rowHeight = rowRect.height;

          const targetScrollTop =
            rowOffsetTop - containerHeight / 2 + rowHeight / 2;

          tableRef.current.scrollTo({
            top: Math.max(0, targetScrollTop),
            behavior: "auto",
          });
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }

    prevReconcileOpenRef.current = isDetailLayout;
  }, [isDetailLayout, selectedDocumentId]);
  useEffect(() => {
    if (isAllSelected) {
      const rows = (Documents.docs || []).flatMap((doc) =>
        location.pathname === "/boletas"
          ? getBoletaRows(doc, t("table.retentionRow.label"), boletaView).map((row) => row.data)
          : [doc]
      );
      setSelectedAmountDocs(rows);
      return setSelectedDocs(rows.map((row) => row._id));
    }
    setSelectedAmountDocs([]);
    setSelectedDocs([]);
  }, [isAllSelected]);

  useEffect(() => {
    // Initialize with proper selectedType based on pathname
    const pathname = location.pathname;
    let initialSelectedType = "ALL";
    
    if (pathname === "/cuotas_de_creditos") {
      initialSelectedType = "CLP";
      dispatch(importDocumentsTypes(["CREDIT"]));
      dispatch(importExcludedDocumentCodes([]));
      setExludedDocuments([]);
    } else if (pathname === "/boletas") {
      initialSelectedType = "FEES";
      dispatch(importDocumentsTypes(["TAX_DOCUMENT"]));
    } else if (pathname === "/obligaciones") {
      initialSelectedType = "OBLIGATION";
      dispatch(importDocumentsTypes(["OBLIGATION"]));
    } else if (pathname === "/documentos_tributarios") {
      initialSelectedType = "ALL";
      dispatch(importDocumentsTypes(["TAX_DOCUMENT"]));
    } else if (isDinPath(pathname)) {
      initialSelectedType = "DIN";
      dispatch(importDocumentsTypes(["TAX_DOCUMENT"]));
      dispatch(importExcludedDocumentCodes(DIN_EXCLUDED_DOCUMENT_CODES));
      setExludedDocuments(DIN_EXCLUDED_DOCUMENT_CODES);
    } else {
      dispatch(importDocumentsTypes(["TAX_DOCUMENT", "OBLIGATION"]));
    }
    
    dispatch(importSelectedType(initialSelectedType));
  }, [companyId, location.pathname]);

  useEffect(() => {
    if (UpdateDocsDate) {
      dispatch(importLastUpdateDateSiiBot(parseInt(UpdateDocsDate?.UpdateDocsDate[0]?.botend)))
    }
  }, [UpdateDocsDate])

  const matchMultipleDocuments = async () => {
    setOpen(false);

    dispatch(
      importAlertState({
        content: t("alerts.settlingBulk"),
        state: "loading",
        duration: 1,
      })
    );
    if (selectedClient[0]) {

      const input = selectedAmountDocs.map((doc) => ({
        id: doc._id,
        amount: doc?.meta?.remaining,
        date: moment(dateToSettle).toDate()
      }))

      dispatch(importNewModal({ show: false }));
      dispatch(setSelectedDocuments([]));

      setSelectedDocs([]);
      setSelectedAmountDocs([])

      const { data: multipleMatchData, error: matchError } = await settleDocument({
        companyId,
        input
      })

      if (!multipleMatchData) {
        // Try to get error message from different sources
        const rawResponse =
          matchError?.graphQLErrors?.[0]?.extensions?.exception?.response;
        const rawMsg = rawResponse ? rawResponse.message?.[0] : "";
        const [_, errorMsg] = rawMsg ? rawMsg.split(".") : [];
        const errorMessage = matchError?.graphQLErrors?.[0]?.message || errorMsg || t("alerts.settledError");
        const isPeriodLocked = isPeriodClosedError(errorMessage);
        return dispatch(
          importAlertState({
            concept: isPeriodLocked ? t("common.periodClosed") : undefined,
            content: errorMessage,
            state: isPeriodLocked ? "warning" : "error",
            duration: isPeriodLocked ? 6 : 4,
          })
        );
      }

      dispatch(importUpdateNominaInProcessNeeded({ value: true }))
      dispatch(setUpdateDocuments({ value: true }));

      return dispatch(
        importAlertState({
          content: t("alerts.settledSuccess"),
          state: "success",
          duration: 5,
        })
      );
    }

    if (Object.keys(documentsFilter ?? {}).length > 0) {
      const input = { companyId, newFilter: documentsFilter, excludeDocumentCodes: excludedDocuments, filter: selectedType };
      const { data, error } = await findAndSettleDocuments({ input });

      dispatch(importNewModal({ show: false }));
      setOpen(false);

      if (!data) {
        const errorMessage = error?.graphQLErrors?.[0]?.message || error?.message || t("alerts.settledError");
        const isPeriodLocked = isPeriodClosedError(errorMessage);
        return dispatch(
          importAlertState({
            concept: isPeriodLocked ? t("common.periodClosed") : undefined,
            content: errorMessage,
            state: isPeriodLocked ? "warning" : "error",
            duration: isPeriodLocked ? 6 : 4,
          })
        );
      }

      dispatch(setUpdateDocuments({ value: true }));
      dispatch(importUpdateNominaInProcessNeeded({ value: true }))

      return dispatch(
        importAlertState({
          content: t("alerts.settledSuccess"),
          state: "success",
          duration: 4,
        })
      );
    }

    dispatch(importNewModal({ show: false }));
    setOpen(false);

    dispatch(
      importAlertState({
        content: t("alerts.settledError"),
        state: "error",
        duration: 4,
      })
    );
  };

  const handleAcuseDeRecibo = () => {
    dispatch(
      importOpenSidebar({
        show: true,
        acceptDocSii: true,
        editData: selectedClient,
        options: { 
          multiple: true,
          documents: Documents,
          selectedDocs: selectedDocs,
          setSelectedDocs: setSelectedDocs
        }
      })
    );
  };

  // Validation function for bulk journal entry
  const canCreateBulkJournalEntry = (selectedDocs) => {
    if (!selectedDocs || selectedDocs.length === 0) return false;
    
    // Check if any document already has entries completed
    const hasCompletedEntries = selectedDocs.some(doc => 
      doc.entries?.completed === true || doc.entryStatus?.completed === true
    );
    if (hasCompletedEntries) {
      return false;
    }

    const hasPendingAcceptance = selectedDocs.some(doc => doc.meta?.state === "PENDIENTE");
    if (hasPendingAcceptance) {
      return false;
    }

    const hasAnnulledDocument = selectedDocs.some(doc => doc.meta?.isValid === false);
    if (hasAnnulledDocument) {
      return false;
    }
    
    // Check all have same documentType
    const firstDocType = selectedDocs[0].documentType;
    if (!selectedDocs.every(doc => doc.documentType === firstDocType)) {
      return false;
    }
    
    // For TAX_DOCUMENT, check same documentCode
    if (firstDocType === 'TAX_DOCUMENT') {
      const firstDocCode = selectedDocs[0].meta?.documentCode;
      return selectedDocs.every(doc => doc.meta?.documentCode === firstDocCode);
    }
    
    // For OBLIGATION, check same meta.type
    if (firstDocType === 'OBLIGATION') {
      const firstMetaType = selectedDocs[0].meta?.type;
      return selectedDocs.every(doc => doc.meta?.type === firstMetaType);
    }
    
    return true;
  };

  const handleOpenBulkJournalEntry = () => {
    setShowBulkJournalEntryModal(true);
  };

  const handlePaymentMethodSelect = (method) => {
    if (isAbonarBlocked()) return;
    const firstDoc = selectedAmountDocs[0];
    const isReceived =
      firstDoc?.meta?.isReceived === true || firstDoc?.meta?.isReceived === false
        ? firstDoc.meta.isReceived
        : true;
    const obligationType = getObligationTypeForPaymentMethod(method.id, isReceived);

    if (obligationType) {
      setPreSelectedObligationType(obligationType);
      setIsPaymentMethod(true);
      setShowAbonoModal(true);
    }
  };

  const openModal = () => {
    const amount =
      selectedClient.length > 0 ? selectedClient.length : totalDocs;
    const subcontent =
      amount > 1
        ? t("bulkSettle.bodyMany", { count: amount })
        : t("bulkSettle.bodyOne");

    const subsubcontent = (
      <Form className='w-100'>
        <Form.Field
          label={t("bulkSettle.paymentDateLabel")}
          control={Input}
          type="date"
          placeholder="Ingrese su Correo"
          name="date"
          onChange={(_, v) => setDateToSettle(v.value)}
          className="w-100"
          fluid
        />
      </Form>
    );

    dispatch(
      importNewModal({
        show: true,
        title: t("bulkSettle.title"),
        subcontent,
        subsubcontent,
        onConfirmText: t("bulkSettle.confirm"),
        onConfirm: matchMultipleDocuments,
        children: <div></div>,
      })
    );
  };

  const filterDocuments = (type) => {
    if (tableRef.current) {
      tableRef.current.scrollTo(0, 0);
    }
    let currentType = searchParams.get('type');

    searchParams.set("type", type);

    history.push({ search: searchParams.toString() });

    if (currentType && currentType != type) {
      onPageChange(null, { activePage: 1 })
      setOffsetUrl(50);
    }
  };

  const filterDocumentsName = (name) => {
    if (!name) {
      searchParams.delete("name");
      searchParams.delete("docNum");
    } else {
      searchParams.set("name", name);
      searchParams.set("docNum", name)
    }

    history.push({ search: searchParams.toString() });
  };

  const onSearchByName = async (name) => {

    debounce(onPageChange({}, { activePage: 1 }));
    debounce(setNameFilter(name));

    const updateSearchValue = debounce((text) => filterDocumentsName(text), 300);

    updateSearchValue(name);
  };

  useEffect(() => {
    // Align with conciliación: apply URL filters after first fetch, or immediately for document detail deep links
    const hasIsUniqueFlow =
      searchParams.get("isUnique") === "true" && searchParams.get("documentId");
    const hasDocumentDetailFlow =
      (searchParams.get("isDocumentDetail") === "true" &&
        (searchParams.get("documentId") || searchParams.get("id"))) ||
      hasIsUniqueFlow;
    if (firstRender && !hasDocumentDetailFlow) {
      return;
    }

    const pathname = location.pathname;
    const urlType = searchParams.get("type");
    const isDocumentDetail = searchParams.get("isDocumentDetail") === "true";
    
    // Determine context based on pathname
    let selectedType = "ALL";
    let contextType = null;
    
    if (pathname === "/cuotas_de_creditos") {
      const validCurrencyTypes = ["CLP", "USD", "UF"];
      selectedType = validCurrencyTypes.includes(urlType) ? urlType : "CLP";
      contextType = "credits";
    } else if (pathname === "/boletas") {
      // Boletas route: only allow boletas-specific tabs
      const validBoletasTypes = ["FEES", "TERCEROS"];
      selectedType = validBoletasTypes.includes(urlType) ? urlType : "FEES";
      contextType = "boletas";
    } else if (pathname === "/obligaciones") {
      // Default to OBLIGATION, but allow ESTIMACION and INVOICES from URL
      if (urlType === "ESTIMACION") {
        selectedType = "ESTIMACION";
      } else if (urlType === "INVOICES") {
        selectedType = "INVOICES";
      } else {
        selectedType = "OBLIGATION";
      }
      contextType = "obligaciones";
    } else if (pathname === "/documentos_tributarios") {
      const validDTETypes = ["ALL", "GIVEN", "RECEIVED"];
      selectedType = validDTETypes.includes(urlType) ? urlType : "ALL";
      contextType = "dtes";
    } else if (isDinPath(pathname)) {
      selectedType = "DIN";
      contextType = "din";
    }

    // Set URL type parameter if not present for new routes, or clean up invalid ones
    if (pathname === "/cuotas_de_creditos" && !urlType) {
      searchParams.set("type", "CLP");
      history.replace({ search: searchParams.toString() });
    } else if (pathname === "/boletas") {
      const validBoletasTypes = ["FEES", "TERCEROS"];
      if (!urlType || !validBoletasTypes.includes(urlType)) {
        searchParams.set("type", "FEES");
        history.replace({ search: searchParams.toString() });
      }
    } else if (pathname === "/obligaciones" && !urlType) {
      // Default to OBLIGATION tab when no type is specified
      searchParams.set("type", "OBLIGATION");
      history.replace({ search: searchParams.toString() });
    } else if (pathname === "/obligaciones" && urlType === "INVOICES") {
      // Ensure INVOICES is properly set in URL
      searchParams.set("type", "INVOICES");
      history.replace({ search: searchParams.toString() });
    } else if (pathname === "/documentos_tributarios") {
      const validDTETypes = ["ALL", "GIVEN", "RECEIVED"];
      if (urlType && !validDTETypes.includes(urlType)) {
        searchParams.delete("type");
        history.replace({ search: searchParams.toString() });
        selectedType = "ALL";
      }
    } else if (isDinPath(pathname) && urlType !== "DIN") {
      searchParams.set("type", "DIN");
      history.replace({ search: searchParams.toString() });
      selectedType = "DIN";
    }

    // Handle pagination params
    const page = searchParams.get("page");
    const offset = searchParams.get("offset");

    if (!page) {
      onPageChange(null, { activePage: 1 })
    }

    if (!offset) {
      onOffsetChange(null, { value: 50 });
    }

    switch (selectedType) {
      case "CLP":
      case "USD":
      case "UF":
        // Credits module: only CREDIT documents, filtered by currencyType
        dispatch(importDocumentsTypes(["CREDIT"]));
        dispatch(importExcludedDocumentCodes([]));
        setExludedDocuments([]);
        dispatch(importDocumentsFilter({
          ...documentsFilter,
          currencyType: selectedType,
          isHidden: false,
        }));
        break;
      case "ALL":
        const isDTEContext = contextType === "dtes" || pathname === "/documentos_tributarios";
        if (isDTEContext) {
          // For DTEs: Only TAX_DOCUMENT, exclude boletas de honorarios (0) and boletas de terceros (1)
          dispatch(importDocumentsTypes(["TAX_DOCUMENT"]));
          dispatch(importExcludedDocumentCodes(["0", "1"])); // Exclude document codes 0 and 1
          setExludedDocuments(["0", "1"]);
        } else {
          // For general context: Include all documents
          dispatch(importDocumentsTypes(["TAX_DOCUMENT", "OBLIGATION"]));
          dispatch(importExcludedDocumentCodes([]));
          setExludedDocuments([]);
        }
        break;
      case "GIVEN":
      case "RECEIVED":
        dispatch(importDocumentsTypes(["TAX_DOCUMENT"]));
        dispatch(importExcludedDocumentCodes(["0", "1"])); // Exclude boletas de honorarios (0) and boletas de terceros (1)
        setExludedDocuments(["0", "1"]);
        break;
      case "FEES":
        dispatch(importDocumentsTypes(["TAX_DOCUMENT"]));
        // For boleta de honorarios: exclude everything except documentCode 0
        dispatch(importExcludedDocumentCodes(["1", "33", "34", "35", "39", "41", "43", "46", "52", "56", "61", "110", "111", "112"]));
        setExludedDocuments(["1", "33", "34", "35", "39", "41", "43", "46", "52", "56", "61", "110", "111", "112"]);
        break;
      case "TERCEROS":
        dispatch(importDocumentsTypes(["TAX_DOCUMENT"]));
        // For boleta de terceros: exclude everything except documentCode 1
        dispatch(importExcludedDocumentCodes(["0", "33", "34", "35", "39", "41", "43", "46", "52", "56", "61", "110", "111", "112"]));
        setExludedDocuments(["0", "33", "34", "35", "39", "41", "43", "46", "52", "56", "61", "110", "111", "112"]);
        break;
      case "OBLIGATION":
        dispatch(importDocumentsTypes(["OBLIGATION"]));
        dispatch(importExcludedDocumentCodes([]));
        setExludedDocuments([]);
        // Exclude invoices, estimaciondeingreso, estimaciondeegreso, and proyeccion
        // Use excludeObligationTypes to exclude these types
        // However, if user has manually set obligationTypes filter, preserve it
        const { type, obligationTypes, excludeObligationTypes, ...restFilter } =
          documentsFilter ?? {};
        if (obligationTypes && Array.isArray(obligationTypes) && obligationTypes.length > 0) {
          // User has applied manual filter, preserve it
          dispatch(importDocumentsFilter({ 
            ...restFilter, 
            type: undefined,
            obligationTypes: obligationTypes,
            excludeObligationTypes: undefined
          }));
        } else {
          // No manual filter, use excludeObligationTypes
          dispatch(importDocumentsFilter({ 
            ...restFilter, 
            type: undefined,
            obligationTypes: undefined,
            excludeObligationTypes: [
              'invoice', 
              'estimaciondeegreso', 
              'estimaciondeingreso', 
              "proyeccion"
            ]
          }));
        }
        break;
      case "ESTIMACION":
        dispatch(importDocumentsTypes(["OBLIGATION"]));
        dispatch(importExcludedDocumentCodes([]));
        setExludedDocuments([]);
        // Set obligationTypes to include only estimaciondeingreso, estimaciondeegreso, and proyeccion
        // Using obligationTypes array since we need multiple types
        dispatch(importDocumentsFilter({ 
          ...documentsFilter, 
          type: undefined,
          obligationTypes: ["estimaciondeingreso", "estimaciondeegreso", "proyeccion"]
        }));
        break;
      case "INVOICES":
        dispatch(importDocumentsTypes(["OBLIGATION"]));
        dispatch(importExcludedDocumentCodes([]));
        setExludedDocuments([]);
        // Use type filter for single type filtering (filters by meta.type for obligations)
        dispatch(importDocumentsFilter({ 
          ...documentsFilter, 
          type: "invoice",
          obligationTypes: undefined
        }));
        break;
      case "DIN":
        dispatch(importDocumentsTypes(["TAX_DOCUMENT"]));
        dispatch(importExcludedDocumentCodes(DIN_EXCLUDED_DOCUMENT_CODES));
        setExludedDocuments(DIN_EXCLUDED_DOCUMENT_CODES);
        break;
      default:
        if (!urlType) filterDocuments("ALL");
        break;
    }

    // Ensure selectedType is always set to a valid value
    dispatch(importSelectedType(selectedType || (pathname === "/cuotas_de_creditos" ? "CLP" : "ALL")));

    let urlParams = {};

    searchParams.forEach((value, key) => {
      if (
        key != "type" &&
        key != "documentType" &&
        key != "documentCodes" &&
        key != "status" &&
        key != "obligationTypes" &&
        key != "page" &&
        key != "offset" && 
        key != "isComment" &&
        key != "isAccounting" && // UI-only flag to open the Accounting tab in inner panel (not a TaxDocumentNewFilter)
        key != "companyId" && // Layout cambia de empresa; no es campo de TaxDocumentNewFilter
        key != "documentId" && // Exclude documentId - it's not a valid field in TaxDocumentNewFilter
        key != "isUnique" && // UI-only: filter list to single document (see below)
        key != "isDocumentDetail" && // Exclude isDocumentDetail - it's only for UI state
        key != "rate" && // Exclude rate - it's not a valid field in TaxDocumentNewFilter (it's a meta property, not a filter)
        !(isDocumentDetail && key === "id") // Exclude id when isDocumentDetail is true (used for modal)
      ) {
        urlParams = {
          ...urlParams,
          ...{ [key]: parseFilterInput(key, value) },
        };
      }

      if (key == "name") {
        setNameFilter(value)
      }

      if (key == "documentType") {
        setDocumentType(value);
      }

      if (
        key == "documentCodes" ||
        key == "status" ||
        key == "obligationTypes"
      ) {
        urlParams = {
          ...urlParams,
          ...{ [key]: parseFilterInput(key, value.split(",")) },
        };
      }

      if (key == 'page') {
        setCurrentPage(Number(value));
      }

      if (key == 'offset') {
        if (value != limit) {
          const numberValue = Number(value);
          const offsetExists = options.some((option) => option.value === numberValue);
          onOffsetChange(null, { value: offsetExists ? numberValue : 50 });
        }
      }
    });

    // Credits module: force currencyType/isHidden filters from the active tab
    if (pathname === "/cuotas_de_creditos") {
      urlParams = {
        ...urlParams,
        currencyType: selectedType,
        isHidden: false,
      };
    }

    // isUnique=true + documentId: list only that document (notification deep links)
    if (hasIsUniqueFlow) {
      urlParams = { ...urlParams, id: searchParams.get("documentId") };
    }

    if (urlParams.name) {
      urlParams.name = urlParams.name.toLowerCase()
    }

    // Set obligationTypes, type, and excludeObligationTypes based on selectedType (from URL or default)
    // These are set programmatically based on tab selection, not from URL params
    // However, if obligationTypes is already in urlParams (from manual filter), preserve it
    if (selectedType === "ESTIMACION") {
      // Only set if not already in URL (user hasn't applied manual filter)
      if (!urlParams.obligationTypes) {
        urlParams.obligationTypes = ["estimaciondeingreso", "estimaciondeegreso", "proyeccion"];
      }
      urlParams.type = undefined;
      urlParams.excludeObligationTypes = undefined;
    } else if (selectedType === "INVOICES") {
      urlParams.type = "invoice";
      // Clear obligationTypes only if user hasn't manually set it
      if (!urlParams.obligationTypes) {
        urlParams.obligationTypes = undefined;
      }
      urlParams.excludeObligationTypes = undefined;
    } else if (selectedType === "OBLIGATION") {
      urlParams.type = undefined;
      // If user has manually set obligationTypes filter, preserve it
      // Otherwise, use excludeObligationTypes to exclude invoices and estimaciones
      if (urlParams.obligationTypes && urlParams.obligationTypes.length > 0) {
        // User has applied manual filter, preserve it and don't set excludeObligationTypes
        urlParams.excludeObligationTypes = undefined;
      } else {
        // No manual filter, use excludeObligationTypes
        urlParams.obligationTypes = undefined;
        urlParams.excludeObligationTypes = ["invoice", "estimaciondeingreso", "estimaciondeegreso", "proyeccion"];
      }
    }

    // Modal overlay (?id=&isDocumentDetail=true): no re-sincronizar filtros Redux desde URL
    const isDocumentDetailModal =
      isDocumentDetail && !searchParams.get('documentId');

    if (!isDocumentDetailModal) {
      delete urlParams.isGlobalSearch;
      dispatch(importDocumentsFilter(urlParams));
    }

    const filteredVariables = Object.fromEntries(
      Object.entries(urlParams).filter(([key, value]) => value !== "" && value !== undefined)
    );

    if (!isDocumentDetailModal && Object.keys(filteredVariables).length === 0) {
      // Preserve obligationTypes, type, and excludeObligationTypes when clearing other filters based on selectedType
      const preservedFilter = {};
      if (selectedType === "ESTIMACION") {
        preservedFilter.obligationTypes = ["estimaciondeingreso", "estimaciondeegreso", "proyeccion"];
      } else if (selectedType === "INVOICES") {
        preservedFilter.type = "invoice";
      } else if (selectedType === "OBLIGATION") {
        // If user has manually set obligationTypes, preserve it
        if (urlParams.obligationTypes && urlParams.obligationTypes.length > 0) {
          preservedFilter.obligationTypes = urlParams.obligationTypes;
        } else {
          preservedFilter.excludeObligationTypes = ["invoice", "estimaciondeingreso", "estimaciondeegreso", "proyeccion"];
        }
      }
      dispatch(importDocumentsFilter(preservedFilter));
    }

    setParametersFetched(true);
  }, [location.search, dispatch, history, firstRender]);

  const setDocumentType = (value) => {
    value = value.split(",");

    const isSelected = value.length > 0;
    const defaultValue = ["TAX_DOCUMENT", "OBLIGATION"];
    setFilterDocumentTypesSelected(isSelected ? value : []);
    dispatch(importDocumentsTypes(isSelected ? value : defaultValue));
    dispatch(setUpdateDocumentsTypes(isSelected ? "UPDATED" : "NEW"));
  };

  useEffect(() => {
    let amountToShow = 0;
    if (selectedAmountDocs.length > 0) {
      selectedAmountDocs.forEach((doc) => {
        const fixer = [61, 112].includes(parseInt(doc.meta.documentCode)) ? -1 : 1
        amountToShow = amountToShow + doc.amount * fixer
      })
    }

    setSelectedAmount(amountToShow);
  }, [selectedAmountDocs])

  useEffect(() => {
    reexecuteQuery()
  }, [updateDocuments])

  const onPageChange = (e, { activePage }) => {
    if (tableRef.current) {
      tableRef.current.scrollTo(0, 0);
    }

    searchParams.set("page", activePage);

    history.push({ search: searchParams.toString() });
  };

  const setOffsetUrl = (value) => {
    searchParams.set("offset", value);

    history.push({ search: searchParams.toString() });
  };

  const onOffsetChange = (e, { value }) => {
    if (parametersFetched) {
      onPageChange(null, { activePage: 1 });
    }
    setLimit(value);
    setSelectedOption(value);

    setOffsetUrl(value);
  };

  useEffect(() => {
    const totalRecords = Documents?.totalDocs;
    const totalPages = Math.ceil(totalRecords / limit);
    setTotalPages(totalPages);
  }, [
    Documents
  ])

  // Render helpers
  const renderFiltersSection = () => (
    <div className={`tw-bg-white tw-p-4 tw-rounded-t-md tw-border tw-border-b-0 tw-border-gray-200 module-search-filter-header tw-min-w-0`}>
      <div className="tw-flex tw-flex-col tw-gap-4 tw-min-w-0">
        <FilterTabs
          tabs={filterTabs}
          activeTab={selectedType}
          onTabChange={filterDocuments}
        />
        <div className="module-search-filter-header__bottom">
          <ModuleSearchBar module="documents" fetching={fetching} />
          <DocumentFilters />
        </div>
        
        {/* Action buttons in separate row - only when there are documents */}
        {Documents?.totalDocs > 0 && (
          <div className="massiveOptionButtons tw-flex">
            {(Object.keys(documentsFilter ?? {}).length > 0 ||
              selectedClient.length > 0) && (
                <>
                  <div>
                    <CustomModal
                      closeIcon
                      open={open}
                      onClose={() => setOpen(false)}
                      size="small"
                      dimmer={{
                        style: {
                          zIndex: 9999,
                          backgroundColor: "rgba(0,0,0,.6)",
                          backdropFilter: "blur(3px)",
                        },
                      }}
                      title={t("bulkSettle.title")}
                      confirmLabel={t("bulkSettle.confirm")}
                      onConfirm={matchMultipleDocuments}
                      content={
                        <>
                        <p>
                          {(() => {
                            const amount = selectedClient?.length || totalDocs?.length;
                            if (!amount) return t("bulkSettle.bodyOne");
                            return amount > 1
                              ? t("bulkSettle.bodyMany", { count: amount })
                              : t("bulkSettle.bodyOne");
                          })()}
                        </p>
                        <Form.Input
                          label={t("bulkSettle.paymentDateLabel")}
                          type="date"
                          placeholder="Ingrese su Correo"
                          name="date"
                          onChange={(_, v) => setDateToSettle(v.value)}
                          className="w-100"
                          fluid
                          defaultValue={today}
                        />
                        </>
                      }
                    />
                  </div>

                  <CostCenterModal
                    isMassive={true}
                    selectedAmount={selectedAmount}
                    setSelectedAmount={setSelectedAmount}
                    companyId={companyId}
                    selectedDocumentsIds={selectedClient}
                    setSelectedDocs={setSelectedDocs}
                    isVisible={openCostCenterModal}
                    setIsVisible={setOpenCostCenterModal}
                    setSelectedAmountDocs={setSelectedAmountDocs}
                  />
                </>
              )}
          </div>
        )}
        
        {/* Empty State Message */}
        {Documents?.totalDocs === 0 && !fetching && !documentIdFromUrl && (
          <div className="tw-text-center tw-py-8 tw-text-gray-500">
            <div className="tw-text-lg tw-mb-2">📄</div>
            <div className="tw-font-medium">
              {isDinPath(location.pathname)
                ? t("emptyState.titleDin")
                : t("emptyState.title")}
            </div>
            <div className="tw-text-sm tw-mt-1">{t("emptyState.hint")}</div>
          </div>
        )}
      </div>
    </div>
  );

  // Expose filter rendering to parent via callback
  useEffect(() => {
    if (renderFilters && !small) {
      renderFilters(renderFiltersSection());
    } else if (renderFilters && small) {
      renderFilters(null); // Clear filters when small
    }
  }, [renderFilters, small, Documents?.totalDocs, selectedType, nameFilter, documentsFilter, selectedClient, fetching, open, openCostCenterModal, selectedAmount, filterTabs, i18n.language]);

  const renderTableHeader = () => {
    const isBoletasRoute = location.pathname === "/boletas";
    const isCreditsRoute = location.pathname === "/cuotas_de_creditos";
    const isDinRoute = isDinPath(location.pathname);
    const gridTemplateColumns = getGridTemplateColumnsForPath(location.pathname);
    const moduleTitle = isDinRoute
      ? t("tabs.din")
      : isBoletasRoute
        ? t("table.moduleTitleBoletas")
        : isCreditsRoute
          ? t("table.moduleTitleCredits")
          : t("table.mobileTitle");

    return (
      <>
        <div className="!tw-block scfo-grid-table-header !tw-h-auto tw-overflow-auto tw-rounded-t-none tw-rounded-b-md tw-w-full">
          {/* Header - Desktop (1024px+) */}
          <div className="tw-w-full tw-hidden lg:tw-flex tw-py-2">
            <div className="tw-w-full tw-flex tw-py-1 tw-items-center">
              {/* Left Section: Checkbox and Document Info */}
              <div className="tw-flex tw-items-center tw-px-4 tw-flex-1 tw-min-w-0 tw-gap-8">
                {/* Checkbox */}
                <div className="tw-w-[40px] tw-flex tw-justify-center tw-items-center tw-flex-shrink-0">
                  <input
                    className="cursor-pointer"
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={(e) => setIsAllSelected(e.target.checked)}
                  />
                </div>
                
                {/* Inner container matching content row structure */}
                {isCreditsRoute ? (
                  <div
                    className="tw-grid tw-items-center tw-flex-1 tw-min-w-0 tw-gap-x-2"
                    style={{ gridTemplateColumns }}
                  >
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.issueDate")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3 tw-min-w-0">{t("table.headers.name")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3 tw-min-w-0">{t("table.headers.identifier")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.installment")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.capital")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.interest")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.installment")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.paymentDate")}</div>
                  </div>
                ) : isBoletasRoute ? (
                  <div
                    className="tw-grid tw-items-center tw-flex-1 tw-min-w-0 tw-gap-x-2"
                    style={{ gridTemplateColumns }}
                  >
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.issueDate")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3 tw-min-w-0">{t("table.headers.businessName")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.rut")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.folio")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.netAmount")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.retention")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.paymentDate")}</div>
                  </div>
                ) : isDinRoute ? (
                  <div
                    className="tw-grid tw-items-center tw-flex-1 tw-min-w-0 tw-gap-x-2"
                    style={{ gridTemplateColumns }}
                  >
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.issueDateLong")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.paymentDate")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.folio")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.form")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.netAmount")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.ivaAmount")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.totalAmount")}</div>
                  </div>
                ) : (
                  <div
                    className="tw-grid tw-items-center tw-flex-1 tw-min-w-0 tw-gap-x-2"
                    style={{ gridTemplateColumns }}
                  >
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.issueDate")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3 tw-min-w-0">{t("table.headers.businessName")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.rut")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3 tw-min-w-0">{t("table.headers.type")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.folio")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.amount")}</div>
                    <div className="scfo-grid-table-header__col tw-px-3">{t("table.headers.paymentDate")}</div>
                  </div>
                )}
              </div>
              
              {/* Right Section: Actions (empty space to match TablaFila geometry) */}
              <div className="tw-flex tw-flex-nowrap tw-items-center tw-px-3 tw-flex-shrink-0 tw-gap-4 tw-justify-end tw-ml-auto">
                {/* Conflict slot */}
                <div className="tw-w-8"></div>
                {/* Comments Badge slot */}
                <div className="tw-w-8"></div>
                {/* Accounting Badge slot */}
                <div className="tw-w-8"></div>
                {/* Progress Bar slot */}
                <div
                  style={{
                    width: PROGRESS_COL_WIDTH_PX,
                    minWidth: PROGRESS_COL_WIDTH_PX,
                    maxWidth: PROGRESS_COL_WIDTH_PX,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Header - Tablet (768px - 1024px) */}
        <div className="tw-w-full tw-hidden md:tw-block lg:tw-hidden tw-p-4 tw-text-center">
          <div className="tw-text-lg tw-font-semibold tw-text-gray-700 tw-uppercase tw-tracking-wide" style={{ fontWeight: 600 }}>
            {moduleTitle}
          </div>
          <div className="tw-text-sm tw-text-gray-500 tw-mt-1">
            {t(isDinRoute ? "table.foundCountDin" : "table.foundCount", { count: Documents?.totalDocs || 0 })}
          </div>
        </div>

        {/* Header - Mobile (<768px) */}
        <div className="tw-w-full tw-block md:tw-hidden tw-p-4 tw-text-center tw-bg-gradient-to-r tw-from-blue-50 tw-to-indigo-50">
          <div className="tw-text-xl tw-font-bold tw-text-gray-800 tw-uppercase tw-tracking-wide" style={{ fontWeight: 600 }}>
            {moduleTitle}
          </div>
          <div className="tw-text-sm tw-text-gray-600 tw-mt-2 tw-flex tw-items-center tw-justify-center tw-gap-2">
            <div className="tw-bg-blue-100 tw-text-blue-800 tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold">
              {t(isDinRoute ? "table.foundCountShortDin" : "table.foundCountShort", { count: Documents?.totalDocs || 0 })}
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderTable = () => (
    <div
      className="tw-w-full tw-flex-1 docTable"
      ref={tableRef}
      style={{
        overflowY: 'auto',
        minHeight: '300px',
        willChange: 'scroll-position'
      }}
    >
      {fetching && !Documents?.docs ? (
        <LoadingCard height={"35px"} quantity={limit} />
      ) : Documents?.docs ? (
        Documents.docs.map((d, i) => (
          <div key={d._id} data-document-id={d._id}>
            <TablaFila
              data={d}
              index={i}
              selected={selectedType}
              isSideBarOpen={show}
              isAllSelected={isAllSelected}
              setIsAllSelected={setIsAllSelected}
              selectedDocs={selectedDocs}
              setSelectedDocs={setSelectedDocs}
              isChecked={selectedDocs.includes(d?._id)}
              small={small}
              setEditTitle={setEditTitle}
              plan={plan}
              eerrAreas={eerrAreas}
              selectedAmountDocs={selectedAmountDocs}
              setSelectedAmountDocs={setSelectedAmountDocs}
              tableRef={tableRef}
              documentsLength={Documents.docs.length}
              selectedDocumentId={selectedDocumentId}
              onOpenReconcile={handleOpenReconcile}
            />
          </div>
        ))
      ) : null}
    </div>
  );

  const renderFooter = () => {
    const totalDocsCount = Documents?.totalDocs || 0
    const pageForShowing = currentPage || 1
    const showingStart = totalDocsCount > 0 ? (pageForShowing - 1) * limit + 1 : 0
    const showingEnd = Math.min(pageForShowing * limit, totalDocsCount)
    return (
    <div className="document__footer">
      <div className="docsTextTrib">
        <div className="docsTextTrib__content">
          <span className="docsTextTrib__text">
            {t("table.showing", { start: showingStart, end: showingEnd, total: totalDocsCount })}
          </span>
          <span className="docsTextTrib__lastBankUpdate">
            {t("table.lastUpdate")} {lastUpdateDateSiiBot && !isNaN(lastUpdateDateSiiBot) ? moment(lastUpdateDateSiiBot).format('DD/MM/YYYY HH:mm') : t("table.noUpdateInfo")}
          </span>
        </div>

        <div className='pagination__container tw-flex tw-items-center tw-gap-3'>
          <Menu compact className="small__dropdown">
            <Dropdown 
              placeholder={t("common.view")} 
              value={selectedOption} 
              onChange={onOffsetChange} 
              options={options} 
              fluid 
              selection 
              style={{ zIndex: 2000 }} 
            />
          </Menu>
          <Pagination
            boundaryRange={0}
            defaultActivePage={1}
            ellipsisItem={null}
            firstItem={null}
            lastItem={null}
            siblingRange={1}
            totalPages={totalPages || 1}
            onPageChange={onPageChange}
            className="small__pagination"
            activePage={currentPage}
          />
        </div>
      </div>
    </div>
    )
  };

  const hasDocuments =
    (Documents?.totalDocs || 0) > 0 || (totalDocs || 0) > 0;
  const shouldShowRowsContainer = fetching || hasDocuments;
  const shouldShowSkeleton = fetching && firstRender && !isDetailLayout;

  return (
    <div 
      className={`tw-w-full tw-flex tw-bg-white${isDetailLayout ? ' tw-overflow-hidden' : ''}`}
      style={{
        flex: isDetailLayout ? '1 1 0%' : undefined,
        minHeight: isDetailLayout ? 0 : undefined,
      }}
    >
      {/* Left Side - Document List */}
      <div 
        className={`tw-transition-all tw-duration-300 tw-bg-white documents-list-panel${isDetailLayout ? ' documents-list-panel--detail-layout' : ''}`}
        style={{
          flex: isDetailLayout ? '0 0 calc(50% - 20.5px)' : '1 1 100%',
          minWidth: 0,
        }}
      >
        {/* Header - Desktop (1024px+) - keep visible during loading to avoid layout jumps */}
        {!isDetailLayout && shouldShowRowsContainer && renderTableHeader()}
        
        {/* Document Rows Container - matches TransactionTable structure */}
        {shouldShowRowsContainer ? (
          <div
            className={isDetailLayout ? 'documents-list-scroll' : 'tw-w-full'}
            ref={tableRef}
          >
            {shouldShowSkeleton ? (
              <>
                {Array.from({ length: SKELETON_ROWS }).map((_, i) => renderSkeletonRow(i))}
              </>
            ) : isDetailLayout &&
              documentIdFromUrl &&
              !Documents?.docs?.length &&
              !fetching ? (
              <div className="tw-text-center tw-py-8 tw-text-gray-500 tw-px-4">
                <div className="tw-font-medium">
                  El documento abierto no está en esta página de resultados.
                </div>
                <div className="tw-text-sm tw-mt-1">
                  Usa la paginación o ajusta filtros para verlo en la lista.
                </div>
              </div>
            ) : Documents?.docs?.length > 0 ? (
              Documents.docs.flatMap((d, i) => {
                const rows = location.pathname === "/boletas"
                  ? getBoletaRows(d, t("table.retentionRow.label"), boletaView)
                  : [{ data: d, isRetention: false }];
                return rows.map((row) => (
                  <div key={row.data._id} data-document-id={row.data._id}>
                    <TablaFila
                      data={row.data}
                      index={i}
                      selected={selectedType}
                      isSideBarOpen={show}
                      isAllSelected={isAllSelected}
                      setIsAllSelected={setIsAllSelected}
                      selectedDocs={selectedDocs}
                      setSelectedDocs={setSelectedDocs}
                      isChecked={selectedDocs.includes(row.data?._id)}
                      small={small}
                      setEditTitle={setEditTitle}
                      plan={plan}
                      eerrAreas={eerrAreas}
                      selectedAmountDocs={selectedAmountDocs}
                      setSelectedAmountDocs={setSelectedAmountDocs}
                      tableRef={tableRef}
                      documentsLength={Documents.docs.length}
                      selectedDocumentId={selectedDocumentId}
                      onOpenReconcile={handleOpenReconcile}
                      progressColWidthPx={PROGRESS_COL_WIDTH_PX}
                      gridTemplateColumns={getGridTemplateColumnsForPath(location.pathname)}
                      isReconcileOpen={isDetailLayout}
                    />
                  </div>
                ));
              })
            ) : null}
          </div>
        ) : null}
        
        {/* Footer fijo bajo la lista; no ocultar durante refetch */}
        {hasDocuments && (
          <div className="document__footer-wrapper" style={{ flexShrink: 0 }}>
            {renderFooter()}
          </div>
        )}
        
        {/* Bulk Actions Bar */}
        {selectedClient.length > 0 && (() => {
          // Check if all selected are obligations (for delete button)
          const allAreObligations = selectedAmountDocs.length > 0 && 
            selectedAmountDocs.every(doc => doc.documentType === "OBLIGATION");
          
          // Check if all selected are RECEIVED (for acuse button)
          const allAreReceived = selectedAmountDocs.length > 0 && 
            selectedAmountDocs.every(doc => doc.meta?.isReceived === true);
          
          // Check if any selected document is fully reconciled (for abonar button)
          const hasFullyReconciledDocs = selectedAmountDocs.some(doc => {
            const remaining = doc.meta?.remaining || doc.remaining || 0;
            return remaining === 0 || remaining === null || remaining === undefined;
          });
          
          // Check if we're on /obligaciones route
          const isObligacionesRoute = location.pathname === "/obligaciones";
          
          // Check if we're on /documentos_tributarios with RECEIVED or ALL type
          const isReceivedType = location.pathname === "/documentos_tributarios" && (selectedType === "RECEIVED" || selectedType === "ALL");
          
          // Check if bulk journal entry is allowed
          const canCreateBulkEntry = canCreateBulkJournalEntry(selectedAmountDocs);

          
          // Determine tooltip message based on which restriction fails
          const getBulkEntryTooltip = () => {
            if (canCreateBulkEntry) return null;
            
            // Check if any document has completed entries
            const hasCompletedEntries = selectedAmountDocs.some(doc => 
              doc.entries?.completed === true || doc.entryStatus?.completed === true
            );
            if (hasCompletedEntries) {
              return t("bulkEntry.hasCompletedEntries");
            }

            const hasPendingAcceptance = selectedAmountDocs.some(doc => doc.meta?.state === "PENDIENTE");
            if (hasPendingAcceptance) {
              return t("bulkEntry.pendingAcceptance");
            }
            
            // Check document type consistency
            const firstDocType = selectedAmountDocs[0]?.documentType;
            const allSameType = selectedAmountDocs.every(doc => doc.documentType === firstDocType);
            if (!allSameType) {
              return t("bulkEntry.sameType");
            }
            
            // Check documentCode for TAX_DOCUMENT
            if (firstDocType === 'TAX_DOCUMENT') {
              const firstDocCode = selectedAmountDocs[0]?.meta?.documentCode;
              const allSameCode = selectedAmountDocs.every(doc => doc.meta?.documentCode === firstDocCode);
              if (!allSameCode) {
                return t("bulkEntry.sameDocCode");
              }
            }
            
            // Check meta.type for OBLIGATION
            if (firstDocType === 'OBLIGATION') {
              const firstMetaType = selectedAmountDocs[0]?.meta?.type;
              const allSameMetaType = selectedAmountDocs.every(doc => doc.meta?.type === firstMetaType);
              if (!allSameMetaType) {
                return t("bulkEntry.sameObligationType");
              }
            }
            
            return t("bulkEntry.generic");
          };
          
          const bulkEntryTooltip = getBulkEntryTooltip();
          
          return (
            <BulkActionsBar
              totalAmountSelected={selectedAmount}
              settleSelected={setOpen}
              costCenters={setOpenCostCenterModal}
              setSelectedDocs={setSelectedDocs}
              totalSelected={selectedDocs.length}
              hideSettleSelected={true}
              deleteTransacitions={
                isObligacionesRoute && allAreObligations ? (
                  <ModalDeleteObligations
                    trigger={
                      <button className='!tw-text-white !tw-bg-transparent tw-border-none'>
                        {t("bulkActions.deleteObligations")}
                      </button>
                    }
                    selectedDocuments={selectedAmountDocs}
                    setSelectedDocs={setSelectedDocs}
                    companyId={companyId}
                    setSelectedAmountDocs={setSelectedAmountDocs}
                  />
                ) : null
              }
              acuseDeRecibo={
                isReceivedType && allAreReceived ? (
                  <button
                    className='!tw-text-white !tw-bg-transparent tw-border-none'
                    onClick={handleAcuseDeRecibo}
                  >
                    {t("bulkActions.ackReceipt")}
                  </button>
                ) : null
              }
              asientoMasivo={
                showAccounting(roles, selectedCompany) && selectedAmountDocs.length > 0 ? (
                  <Popup
                    content={bulkEntryTooltip}
                    disabled={!bulkEntryTooltip}
                    inverted
                    trigger={
                      <button
                        className='!tw-text-white !tw-bg-transparent tw-border-none'
                        onClick={handleOpenBulkJournalEntry}
                        disabled={!canCreateBulkEntry}
                        style={{ 
                          opacity: canCreateBulkEntry ? 1 : 0.5,
                          cursor: canCreateBulkEntry ? 'pointer' : 'not-allowed'
                        }}
                      >
                        {tAccounting("common.bulkEntry")}
                      </button>
                    }
                  />
                ) : null
              }
              desconciliar={
                docsWithMatches.length > 0 && !isConciliacionBlocked() ? (
                  <Popup
                    content={!canBulkUnmatch ? t("bulkActions.unmatchMixedTypes") : null}
                    disabled={canBulkUnmatch}
                    inverted
                    trigger={
                      <button
                        className='!tw-text-white !tw-bg-transparent tw-border-none'
                        onClick={() => setShowBulkUnmatchModal(true)}
                        disabled={!canBulkUnmatch || bulkUnmatch.inFlight}
                        style={{
                          opacity: canBulkUnmatch && !bulkUnmatch.inFlight ? 1 : 0.5,
                          cursor: canBulkUnmatch && !bulkUnmatch.inFlight ? 'pointer' : 'not-allowed',
                        }}
                      >
                        {bulkUnmatch.inFlight
                          ? t("bulkActions.unmatchInProgress")
                          : t("bulkActions.unmatch", { count: docsWithMatches.length })}
                      </button>
                    }
                  />
                ) : null
              }
              abonar={
                !isAbonarBlocked() && selectedAmountDocs.length > 0 && !hasFullyReconciledDocs ? (
                  <PaymentMethodDropdown
                    onSelect={handlePaymentMethodSelect}
                    disabled={hasFullyReconciledDocs}
                    isReceived={selectedAmountDocs.length > 0 && selectedAmountDocs[0]?.meta?.isReceived === true || selectedAmountDocs[0]?.meta?.isReceived === false
                      ? selectedAmountDocs[0].meta.isReceived 
                      : true}
                    variant="dark"
                    direction="up"
                  />
                ) : null
              }
            />
          );
        })()}

        <BulkUnmatchModal
          open={showBulkUnmatchModal}
          onClose={() => setShowBulkUnmatchModal(false)}
          selection={
            unmatchGroups.length > 1
              ? { groups: unmatchGroups }
              : {
                  type: bulkUnmatchType,
                  ids: docsWithMatches.map((doc) => doc._id || doc.id),
                }
          }
          preview={bulkUnmatch.preview}
          previewing={bulkUnmatch.previewing}
          launching={bulkUnmatch.launching}
          runPreview={bulkUnmatch.runPreview}
          runPreviewGroups={bulkUnmatch.runPreviewGroups}
          onConfirm={async (selection) => {
            const job = await bulkUnmatch.launch(selection);
            if (job) setShowBulkUnmatchModal(false);
          }}
        />

        <BulkUnmatchProgress
          job={bulkUnmatch.job}
          percent={bulkUnmatch.percent}
          onCancel={bulkUnmatch.cancel}
          onRetry={bulkUnmatch.retry}
          onClose={bulkUnmatch.reset}
        />
      </div>
      <div 
        className="tw-flex-shrink-0 tw-transition-all tw-duration-300 tw-ease-in-out"
        style={{
          width: isDetailLayout ? '1px' : '0',
          marginLeft: isDetailLayout ? '20px' : '0',
          marginRight: isDetailLayout ? '20px' : '0',
          borderLeft: 'none', // Removed dotted border
          height: '100%',
          opacity: 0, // Hidden
          overflow: 'hidden',
        }}
      />

      {/* Right Side - Reconcile/Detail Panel */}
      <div 
        className="tw-transition-all tw-duration-300 tw-ease-in-out tw-bg-white tw-flex tw-flex-col tw-overflow-hidden documents-list-panel"
        style={{
          flex: isDetailLayout ? '0 0 calc(50% - 20.5px)' : '0 0 0',
          minWidth: 0,
          opacity: isDetailLayout ? 1 : 0,
          maxWidth: isDetailLayout ? 'calc(50% - 20.5px)' : '0',
          overflow: 'hidden',
        }}
      >
        {isDetailLayout && (
          <>
            {/* Header with Close Button */}
            <div className="tw-flex tw-items-center tw-justify-end tw-px-4 tw-py-3 tw-border-b tw-border-gray-200">
              <div 
                onClick={handleCloseReconcile} 
                className="tw-cursor-pointer tw-flex tw-items-center tw-justify-center"
                style={{ 
                  marginTop: '4px',
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img
                  style={{ height: "18px", width: "18px", display: 'block' }}
                  src={iconEquis}
                  alt="cerrar"
                />
              </div>
            </div>
            
            <div className="documents-reconcile-scroll">
              <Reconcile setCheckedTransactions={() => {}} />
            </div>
          </>
        )}
      </div>

      {/* Bulk Journal Entry Modal */}
      {selectedAmountDocs.length > 0 && (
        <CreateJournalEntryModal
          open={showBulkJournalEntryModal}
          onClose={() => setShowBulkJournalEntryModal(false)}
          onEntryCreated={() => {
            setShowBulkJournalEntryModal(false);
            setSelectedDocs([]);
            setSelectedAmountDocs([]);
          }}
          editData={
            selectedAmountDocs.length > 0
              ? {
                  originType: selectedAmountDocs[0].documentType,
                  localAmount: selectedAmountDocs[0].amount || selectedAmountDocs[0].localValue || 0,
                  sources: [{ type: 'DOCUMENT', id: selectedAmountDocs[0].id || selectedAmountDocs[0]._id }],
                  support: {
                    documents: [selectedAmountDocs[0]],
                    transactions: []
                  },
                  origin: 'DOCUMENT'
                }
              : null
          }
          bulkDocuments={selectedAmountDocs}
        />
      )}
      {/* CreateObligationModal for bulk abonar action */}
      <CreateObligationModal
        open={showAbonoModal && !isAbonarBlocked()}
        onClose={() => {
          setShowAbonoModal(false);
          setPreSelectedObligationType(null);
          setIsPaymentMethod(false);
        }}
        onSuccess={() => {
          dispatch(setUpdateDocuments({ value: true }));
          setSelectedDocs([]);
          setSelectedAmountDocs([]);
        }}
        initialData={showAbonoModal && selectedAmountDocs.length > 0 ? {
          selectedDocuments: selectedAmountDocs,
          remaining: selectedAmountDocs.reduce((sum, doc) => {
            const remaining = doc.meta?.remaining || doc.remaining || doc.amount || 0;
            return sum + Math.abs(remaining);
          }, 0),
          currency: selectedAmountDocs[0]?.currencyType || selectedAmountDocs[0]?.currency || 'CLP',
          date: moment().toDate(),
          isMultiple: true,
          isMultipleDocuments: true, // Flag to distinguish from transactions
          // Include first document data for compatibility
          ...selectedAmountDocs[0],
          documentType: selectedAmountDocs[0]?.documentType || 'TAX_DOCUMENT'
        } : null}
        preSelectedObligationType={preSelectedObligationType}
        isPaymentMethod={isPaymentMethod}
      />
    </div>
  );
};

export default TablaDocumentos;
